import { Box } from "grommet";

const CenteredColumn = (props) => {
  return (
    <Box direction="row" justify="center" {...props}>
      <Box width={props.columnWidth || "xlarge"}>{props.children}</Box>
    </Box>
  );
};
export default CenteredColumn;